// This file was generated using `pay js:run gql-v1 --type=fragment --name=AdditionalVerificationsArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';
import type {
  Exact,
  Scalars,
  OpenapiAdditionalVerificationsResourceDocumentAdditionalVerificationApplyToEnum,
  OpenapiAdditionalVerificationsResourcePersonIdentityAdditionalVerificationApplyToEnum,
  OpenapiAdditionalVerificationsResourceUsW8OrW9W8ConfigurationIncomeTypesEnum,
  OpenapiAdditionalVerificationsResourceUsW8OrW9W8ConfigurationTypeEnum,
} from '@stripe-internal/data-v1/schema/types';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import {stripeAccountCapabilitiesRequirementsArkFragment} from './stripeAccountCapabilitiesRequirementsArkFragment';

import type {StripeAccountCapabilitiesRequirementsArkFragmentData} from './stripeAccountCapabilitiesRequirementsArkFragment';

const doc = gql`
  fragment AdditionalVerificationsArkFragment on OpenapiAdditionalVerificationsResourceAdditionalVerifications {
    address {
      requested
      requested_at
      requirements {
        ...StripeAccountCapabilitiesRequirementsArkFragment
      }
      status
      time_limits
      upfront
      volume_limits
    }
    document {
      apply_to
      requested
      requested_at
      require_live_capture
      require_matching_selfie
      requirements {
        ...StripeAccountCapabilitiesRequirementsArkFragment
      }
      status
      upfront
      volume_limits
    }
    person_identity {
      apply_to
      requested
      requested_at
      requirements {
        ...StripeAccountCapabilitiesRequirementsArkFragment
      }
      status
      upfront
      volume_limits
    }
    tax_id {
      requested
      requested_at
      requirements {
        ...StripeAccountCapabilitiesRequirementsArkFragment
      }
      status
      time_limits
      upfront
      volume_limits
    }
    us_w8_or_w9 {
      requested
      requested_at
      requirements {
        ...StripeAccountCapabilitiesRequirementsArkFragment
      }
      status
      time_limits
      upfront
      volume_limits
      w8 {
        income_types
        type
      }
    }
  }

  ${stripeAccountCapabilitiesRequirementsArkFragment}
`;

export const additionalVerificationsArkFragment: AdditionalVerificationsArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type AdditionalVerificationsArkFragmentData = {
  readonly __typename: 'OpenapiAdditionalVerificationsResourceAdditionalVerifications';
  readonly address: {
    readonly __typename: 'OpenapiAdditionalVerificationsResourceAddressAdditionalVerification';
    readonly requested: boolean;
    readonly requested_at: number | null;
    readonly status: string;
    readonly time_limits: ReadonlyArray<Scalars['JSONObject']> | null;
    readonly upfront: ReadonlyArray<Scalars['JSONObject']> | null;
    readonly volume_limits: ReadonlyArray<Scalars['JSONObject']> | null;
    readonly requirements: GraphQlFragmentUnion<
      {readonly __typename: 'OpenapiAccountRequirements'},
      [StripeAccountCapabilitiesRequirementsArkFragmentData]
    >;
  } | null;
  readonly document: {
    readonly __typename: 'OpenapiAdditionalVerificationsResourceDocumentAdditionalVerification';
    readonly apply_to: ReadonlyArray<OpenapiAdditionalVerificationsResourceDocumentAdditionalVerificationApplyToEnum> | null;
    readonly requested: boolean;
    readonly requested_at: number | null;
    readonly require_live_capture: boolean | null;
    readonly require_matching_selfie: boolean | null;
    readonly status: string;
    readonly upfront: ReadonlyArray<Scalars['JSONObject']> | null;
    readonly volume_limits: ReadonlyArray<Scalars['JSONObject']> | null;
    readonly requirements: GraphQlFragmentUnion<
      {readonly __typename: 'OpenapiAccountRequirements'},
      [StripeAccountCapabilitiesRequirementsArkFragmentData]
    >;
  } | null;
  readonly person_identity: {
    readonly __typename: 'OpenapiAdditionalVerificationsResourcePersonIdentityAdditionalVerification';
    readonly apply_to: ReadonlyArray<OpenapiAdditionalVerificationsResourcePersonIdentityAdditionalVerificationApplyToEnum> | null;
    readonly requested: boolean;
    readonly requested_at: number | null;
    readonly status: string;
    readonly upfront: ReadonlyArray<Scalars['JSONObject']> | null;
    readonly volume_limits: ReadonlyArray<Scalars['JSONObject']> | null;
    readonly requirements: GraphQlFragmentUnion<
      {readonly __typename: 'OpenapiAccountRequirements'},
      [StripeAccountCapabilitiesRequirementsArkFragmentData]
    >;
  } | null;
  readonly tax_id: {
    readonly __typename: 'OpenapiAdditionalVerificationsResourceTaxIdAdditionalVerification';
    readonly requested: boolean;
    readonly requested_at: number | null;
    readonly status: string;
    readonly time_limits: ReadonlyArray<Scalars['JSONObject']> | null;
    readonly upfront: ReadonlyArray<Scalars['JSONObject']> | null;
    readonly volume_limits: ReadonlyArray<Scalars['JSONObject']> | null;
    readonly requirements: GraphQlFragmentUnion<
      {readonly __typename: 'OpenapiAccountRequirements'},
      [StripeAccountCapabilitiesRequirementsArkFragmentData]
    >;
  } | null;
  readonly us_w8_or_w9: {
    readonly __typename: 'OpenapiAdditionalVerificationsResourceUsW8OrW9AdditionalVerification';
    readonly requested: boolean;
    readonly requested_at: number | null;
    readonly status: string;
    readonly time_limits: ReadonlyArray<Scalars['JSONObject']> | null;
    readonly upfront: ReadonlyArray<Scalars['JSONObject']> | null;
    readonly volume_limits: ReadonlyArray<Scalars['JSONObject']> | null;
    readonly requirements: GraphQlFragmentUnion<
      {readonly __typename: 'OpenapiAccountRequirements'},
      [StripeAccountCapabilitiesRequirementsArkFragmentData]
    >;
    readonly w8: {
      readonly __typename: 'OpenapiAdditionalVerificationsResourceUsW8OrW9W8Configuration';
      readonly income_types: ReadonlyArray<OpenapiAdditionalVerificationsResourceUsW8OrW9W8ConfigurationIncomeTypesEnum> | null;
      readonly type: OpenapiAdditionalVerificationsResourceUsW8OrW9W8ConfigurationTypeEnum;
    };
  } | null;
};

export type AdditionalVerificationsArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const additionalVerificationsArkFragmentPermissions = {
  ...stripeAccountCapabilitiesRequirementsArkFragment.permissions,
} as const;

doc.permissions = additionalVerificationsArkFragmentPermissions;

export type AdditionalVerificationsArkFragmentPermissions = V1PermissionToken<
  typeof additionalVerificationsArkFragmentPermissions
>;

export type AdditionalVerificationsArkFragmentDocument = GraphQlDocument<
  AdditionalVerificationsArkFragmentData,
  AdditionalVerificationsArkFragmentVariables,
  AdditionalVerificationsArkFragmentPermissions
>;
